// Local copy of shared's R3Chat/MessageList.tsx MarkdownContent — kept ros-app-only so this
// package never mixes its own @mui/material instance with shared's inside one component tree
// (that mix is what caused the "styled_default is not a function" dual-MUI-instance crash).
import Box from '@mui/material/Box'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Link } from 'react-router-dom'

export function MarkdownContent({ content }: { content: string }) {
  return (
    <Box
      sx={{
        '& p': { m: 0, lineHeight: 1.65, '& + p': { mt: 1 } },
        '& ul, & ol': { pl: 2.5, m: 0, '& + *': { mt: 0.5 } },
        '& li': { lineHeight: 1.65, mb: 0.25 },
        '& strong': { fontWeight: 700 },
        '& a': { color: 'primary.main', textDecoration: 'none', fontWeight: 500, '&:hover': { textDecoration: 'underline' } },
        '& code': { fontFamily: 'monospace', fontSize: '0.8em', bgcolor: 'action.hover', px: 0.5, py: 0.25, borderRadius: 0.5 },
        fontSize: '0.875rem',
      }}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => {
            if (href?.startsWith('/')) return <Link to={href}>{children}</Link>
            return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
          },
          p: ({ children }) => <p style={{ margin: 0, lineHeight: 1.65 }}>{children}</p>,
          code: ({ className, children, ...props }: any) => {
            const isBlock = className?.startsWith('language-')
            if (isBlock) {
              const language = className.replace('language-', '')
              if (language === 'html' || language === 'css') return null
            }
            return <code className={className} {...props}>{children}</code>
          },
          pre: ({ children }: any) => <>{children}</>,
        }}
      >
        {content}
      </ReactMarkdown>
    </Box>
  )
}
